import { emptyAdminApi as api } from "../emptyAdminApi";

export type SimplyWebUser = {
  username: string;
  sub?: string;
  email?: string;
  emailVerified?: boolean;
  name?: string;
  birthdate?: string;
  enabled: boolean;
  status?: string;
  createdAt?: string;
  updatedAt?: string;
};

export type ListSimplyWebUsersResponse = {
  users: SimplyWebUser[];
};

export type SaveSimplyWebUserRequest = {
  username: string;
  email: string;
  name?: string;
  birthdate?: string;
  enabled?: boolean;
  temporaryPassword?: string;
  suppressInvite?: boolean;
};

export type SaveSimplyWebUserResponse = {
  user: SimplyWebUser;
};

export type ResetSimplyWebUserPasswordResponse = {
  username: string;
  message: string;
};

export const addTagTypes = ["SimplyWebUsers"] as const;

const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getSimplyWebUsers: build.query<ListSimplyWebUsersResponse, { search?: string } | void>({
        query: (args) => {
          const search = args && "search" in args ? args.search : undefined;
          const query = search ? `?search=${encodeURIComponent(search)}` : "";
          return {
            url: `/portal/simply-users${query}`,
            method: "GET",
          };
        },
        providesTags: ["SimplyWebUsers"],
      }),
      createSimplyWebUser: build.mutation<SaveSimplyWebUserResponse, SaveSimplyWebUserRequest>({
        query: (body) => ({
          url: "/portal/simply-users",
          method: "POST",
          body,
        }),
        invalidatesTags: ["SimplyWebUsers"],
      }),
      updateSimplyWebUser: build.mutation<SaveSimplyWebUserResponse, SaveSimplyWebUserRequest>({
        query: (body) => ({
          url: "/portal/simply-users",
          method: "PUT",
          body,
        }),
        invalidatesTags: ["SimplyWebUsers"],
      }),
      disableSimplyWebUser: build.mutation<{ username: string; enabled: boolean }, string>({
        query: (username) => ({
          url: "/portal/simply-users?username=" + encodeURIComponent(username),
          method: "DELETE",
        }),
        invalidatesTags: ["SimplyWebUsers"],
      }),
      resetSimplyWebUserPassword: build.mutation<ResetSimplyWebUserPasswordResponse, string>({
        query: (username) => ({
          url: "/portal/simply-users?action=reset-password",
          method: "POST",
          body: { username },
        }),
      }),
    }),
  });

export const {
  useGetSimplyWebUsersQuery,
  useCreateSimplyWebUserMutation,
  useUpdateSimplyWebUserMutation,
  useDisableSimplyWebUserMutation,
  useResetSimplyWebUserPasswordMutation,
} = injectedRtkApi;
